// Prace serwisowe i zlecenia. Sekcja jest ukryta w menu, więc mockup
// (design/voicesphere-dashboard.html) jej nie zna.
//
// VERIFY: cały plik, brak w mockupie. Terminy: „maintenance" = „prace serwisowe",
// „work order" = „zlecenie" (lista i szuflada pokazują pojedyncze zlecenia, stąd rodzaj nijaki).
//
// Klucze `status.*`, `priority.*`, `createdBy.*` to dokładnie wartości enumów z API
// (`in_progress`, `critical`, ...), bo komponenty składają klucz z wartości:
// t(`status.${value}`). Wartość w logice zostaje angielska, tłumaczy się tylko etykieta.
export default {
  header: {
    refresh: 'Odśwież',
    // Licznik w nagłówku jest dwuwierszowy (CustomTableHeader): wiersz 1, <br>, wiersz 2.
    countLine1: 'Liczba',
    countLine2: 'zleceń',
  },
  // Nazwy pól: nagłówki kolumn tabeli, etykiety szuflady i placeholdery filtrów.
  fields: {
    id: 'ID',
    company: 'Firma',
    phone: 'Numer telefonu',
    description: 'Opis',
    // VERIFY: „property" w kontekście Yardi (zarządzanie nieruchomościami) = „nieruchomość".
    hasProperty: 'Ma nieruchomość',
    status: 'Status',
    priority: 'Priorytet',
    createdBy: 'Utworzone przez',
    created: 'Utworzono',
    updated: 'Zaktualizowano',
    yardiId: 'Yardi ID',
    notes: 'Notatki',
  },
  status: {
    open: 'Otwarte',
    closed: 'Zamknięte',
    // VERIFY: „WIP" (work in progress) skrócone do „W toku".
    in_progress: 'W toku',
  },
  priority: {
    critical: 'Krytyczny',
    high: 'Wysoki',
    medium: 'Średni',
    low: 'Niski',
  },
  createdBy: {
    yardi: 'Yardi',
    // VERIFY: nazwa marki z oryginału; mockup nazywa produkt VoiceSphere.
    respondit: 'Respondit',
  },
  table: {
    show: 'Pokaż',
  },
  card: {
    title: 'Zlecenie',
  },
  drawer: {
    title: 'Szczegóły zlecenia',
    descriptionPlaceholder: 'Wpisz opis',
  },
} as const;
